import React from 'react';
import PropTypes from 'prop-types';
import {
  Checkbox,
  Collapse,
  Divider,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { formatMoney } from '../../../../../../helpers/tools';

import CCMovimiento from '../movimiento';

const CCTipoItem = ({
  cantidad,
  click,
  countCheck,
  enable,
  id,
  label,
  movimientos,
  totalCheck,
  type,
}) => {
  const [open, setOpen] = React.useState(false);
  return (
    <List key={id}>
      <ListItem
        button
        className="detalle_box detalle_box_divider"
        onClick={() => setOpen(!open)}
      >
        {open ? (<ExpandLess />) : (<ExpandMore />)}
        <ListItemText
          primary={(
            <>
              <Typography component="span" variant="body2" color="textPrimary">
                <div className="balance-detalles__flex-space">
                  <strong>{label}</strong>
                  <span className="detalle_cantidad">{`${countCheck} / ${cantidad}`}</span>
                  <strong>{`$ ${formatMoney(totalCheck)}`}</strong>
                </div>
              </Typography>
            </>
          )}
        />
        <Checkbox
          data-id={id}
          data-kind={type}
          checked={Boolean(enable)}
          onClick={(e) => {
            const { currentTarget } = e;
            click(currentTarget);
            e.preventDefault();
            e.stopPropagation();
          }}
          className="balance-detalles__no-padding-lr"
        />
      </ListItem>
      <Collapse in={open} timeout="auto" className="detalle_box-wrapper">
        <CCMovimiento
          movimientos={movimientos}
          click={click}
        />
      </Collapse>
      <Divider className="my-1" />
    </List>
  );
};

CCTipoItem.propTypes = {
  cantidad: PropTypes.number,
  click: PropTypes.func.isRequired,
  countCheck: PropTypes.number,
  enable: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  movimientos: PropTypes.array,
  totalCheck: PropTypes.number,
  type: PropTypes.string,
};

CCTipoItem.defaultProps = {
  cantidad: 0,
  countCheck: 0,
  enable: false,
  label: '',
  movimientos: [],
  totalCheck: 0,
  type: '',
};

export default CCTipoItem;
